"use client";

import React from "react";
import { Switch } from "~/components/ui/switch";

type Props = {
  isFullMode: boolean;
  setIsFullMode: (v: boolean) => void;
  isSolvedOnlyMode: boolean;
  setIsSolvedOnlyMode: (v: boolean) => void;
};

export default function StatsControls({
  isFullMode,
  setIsFullMode,
  isSolvedOnlyMode,
  setIsSolvedOnlyMode,
}: Props) {
  return (
    <div className="flex items-center gap-4">
      <label className="flex items-center gap-2">
        <span className="text-sm">Подробно</span>
        <Switch
          checked={isFullMode}
          onCheckedChange={setIsFullMode}
          data-testid="mode-switch"
          role="switch"
        />
      </label>

      <label className="flex items-center gap-2">
        <span className="text-sm">% только по решенным</span>
        <Switch
          checked={isSolvedOnlyMode}
          onCheckedChange={setIsSolvedOnlyMode}
          data-testid="solved-only-switch"
          role="switch"
        />
      </label>
    </div>
  );
}
